module.exports = __webpack_public_path__ + "img/中文.c6d9b9c8.png";